import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { FormGroup } from '../../../../../ui/gzForm/formGroup/form-group';

export class IntegrityMonitorCustomRuleActionsFormView extends BaseWebComponentView {
  public formGroup: FormGroup;

  public dom: {
    $actionsLabel: HTMLElement;
    $actionsContainer: HTMLElement;
  };

  getDomElements() {
    this.formGroup = FormGroup.build({});

    this.dom = {
      $actionsLabel: this.shadow.querySelector('#rules-actions-label'),
      $actionsContainer: this.shadow.querySelector('#rules-actions-container'),
    };

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.translations = this.stringsTranslator.getIntegrityMonitorStrings().integrityMonitorRules.customRuleForm;
  }

  setTranslatedStrings() {
    this.dom.$actionsLabel.innerHTML = this.translations.actionsLabel + ' *:';
  }

  buildSuccessView(data: any) {}
}
